"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("clipPath", {
    id: "prefix__a"
  }, (0, _pragma.createFelaElement)("path", {
    d: "M0 0h16v16H0z"
  })), (0, _pragma.createFelaElement)("g", {
    clipPath: "url(#prefix__a)"
  }, (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M8.056 12.216c1.704 0 3.084-.936 3.084-2.568 0-.6-.168-1.068-.492-1.416s-.672-.576-1.044-.708-.864-.276-1.476-.408C7 6.864 6.412 6.66 6.364 5.856c0-.72.588-1.092 1.536-1.092s1.512.384 1.56 1.308h1.572c0-.876-.288-1.536-.876-1.992-.576-.456-1.308-.684-2.208-.684-1.728 0-3.12.912-3.12 2.58 0 1.116.66 1.776 1.428 2.1.396.156.852.3 1.392.432.48.108.84.204 1.068.276s.432.18.6.336c.18.156.264.36.264.624 0 .684-.684 1.14-1.536 1.14-1.008 0-1.836-.576-1.884-1.74H4.6c0 2.016 1.656 3.072 3.456 3.072z"
  })));
}

var _default = 'src/asset/icon/sell.icon.svg';
exports.default = _default;
//# sourceMappingURL=sell.icon.js.map